<div class="popover-class">
  <div class="popover-title">LOGIC FLOW</div>
  <div>0 - select an order</div>
  <div>1 - select a product of that order</div>
  <div>2 - add a “lotto” of that product</div>
  <div>3- choose period & range</div>
  <div>4 - upload documents</div>
  <div>5 - add another “lotto” or finish</div>
  <div>6 - repeat the steps for all the “lotto”</div>
  <div>7 - select another product</div>
  <div>8 - repeat the steps for all the products</div>
  <div>9 - confirm & save</div>
  <div>10 - order saved in “Storico ordini”</div>
  <div class="popover-title">NOTE</div>
  <div>
    I’ve added comments to better explain the procedure. Please take a look
  </div>
  <div>If anything is not clear, ask me anytime</div>
  <div class="popover-title">CHANGES</div>
  <div>
    A “lotto” of a product can be edit anytime during the order preparation.
  </div>
  <div>In the ‘lotto details’ modal frame you could press:</div>
  <div>
    “MODIFICA” button →‘Fornitori - order preparation 2/5 - add "lotto"(1/2)’
    frame
  </div>
  <div>
    “AGGIUNGI CERTIFICATO” button -> ‘Fornitori - order preparation 3/5 - add
    "lotto"(2/2)’
  </div>
</div>
